import {
  Container,
  Title,
  Text,
  Group,
  Card,
  SimpleGrid,
  Image,
  Box,
  Button,
  ThemeIcon,
  Grid,
  Center,
  Paper,
  Badge,
} from "@mantine/core";
import {
  IconArrowRight,
  IconStar,
  IconUsers,
  IconBrush,
} from "@tabler/icons";
import classes from "../styles/HomePage.module.css";

export function BusinessCategoriesSection() {
  // תמונות מותאמות לכל קטגוריה עסקית
  const businessCategories = [
    {
      title: "קוסמטיקאיות ומטפלות יופי",
      description:
        "ניהול יעיל של טיפולים, אישורי הגעה שלא אושרו המערכת תבטל את התור לפי טווח זמנים שתגדירו ותפנה אותו ללקוחה אחרת כך שאין יותר הפתעות וחורים ביומן! ובנוסף ניהול מלאי כולל התראות אוטומטיות בווטצאפ !", image: "/קוסמטיקאית2.webp",
      altText: "קוסמטיקאית ומטפלת יופי מנהלת קליניקה ויומן תורים עם מערכת חכמה",
      icon: <IconStar size={24} />,
      link: "/queue-management-beauticians",
      features: [
        "ניהול סדרות טיפולים",
        "תזכורות בווצטאפ לטיפולי המשך",
        "אישור הגעה בלחיצת כפתור",
        "שליחת חשבוניות ללקוחות",
        // "כרטיסי לקוח עם היסטוריית טיפולים",
      ],
      color: "pink",
    },
    {
      title: "מספרות ועיצוב שיער",
      description:
        "מערכת ניהול תורים למספרות - יומן מספרה דיגיטלי, הזמנת תורים אונליין למספרה, ניהול מספר ספרים במקביל. דף עסקי למספרה מקודם בגוגל, תשלום מראש למספרה וניהול סוגי שירותים - תספורת, צביעת שיער ועיצוב שיער.",
      image: "/hairsalon-with-phone.webp",
      altText: "ספר ובעל מספרה מנהל יומן תורים דיגיטלי וסליקה אונליין",
      icon: <IconUsers size={24} />,
      link: "/managing-queues-hair-salons",
      features: [
        "ניהול מספר ספרים במקביל",
        "הזמנת תורים אונליין למספרה",
        "תשלום מראש למספרה",
        "דף עסקי למספרה מקודם בגוגל",
      ],
      color: "blue",
    },
    {
      title: "נייליסטיות ומניקוריסטיות",
      description:
        "מערכת ניהול תורים מושלמת לנייליסטיות. תזכורות אוטומטיות, גביית מקדמות בקביעת התור למניעת הברזות, רשימת המתנה חכמה למילוי חורים ביומן, ותזכורות וואטסאפ ללא הגבלה במחיר הכל-כלול של 99 ש״ח.",
      image: "/קוסמטיקאית.webp",
      altText: "מניקוריסטית ונייליסטית מתזמנת תורים עם תזכורות וואטסאפ למניעת הברזות",
      icon: <IconBrush size={24} />,
      link: "/queue-management-nail-techs",
      features: [
        "תזכורות אוטומטיות בווטסאפ ללא הגבלה",
        "רשימת המתנה חכמה למילוי חורים ביומן",
        "גביית מקדמות בקביעת התור",
        "דף עסקי מעוצב אישית",
      ],
      color: "teal",
    },

    //   {
    //     title: "מדריכים ומורים פרטיים",
    //     description: "ניהול קל של שיעורים פרטיים וקבוצתיים, מעקב אחר התקדמות תלמידים וגביית תשלומים מסודרת.",
    //     image: "/education-business.webp", // יש להוסיף תמונה מתאימה
    //     icon: <IconUsers size={24} />,
    //     link: "/nihuol-torim-morim",
    //     features: ["שיעורים פרטיים וקבוצתיים", "מעקב התקדמות תלמידים", "חבילות שיעורים מובנות"],
    //     color: "violet"
    //   },
    //   {
    //     title: "מאמנים ומדריכי כושר",
    //     description: "ניהול אימונים אישיים וקבוצתיים, מעקב אחר התקדמות מתאמנים, ותוכניות אימון מותאמות אישית.",
    //     image: "/fitness-business.webp", // יש להוסיף תמונה מתאימה
    //     icon: <IconUsers size={24} />,
    //     link: "/nihuol-torim-kosher",
    //     features: ["קביעת אימונים אישיים וקבוצתיים", "מעקב אחר התקדמות", "חבילות אימונים"],
    //     color: "orange"
    //   },
    //   {
    //     title: "עסקים מבוססי פגישות",
    //     description: "פתרון מושלם לכל עסק שמבוסס על פגישות: יועצים, מתווכים, עורכי דין, רואי חשבון ועוד.",
    //     image: "/meetings-business.webp", // יש להוסיף תמונה מתאימה
    //     icon: <IconBuildingStore size={24} />,
    //     link: "/nihuol-torim-pgishiot",
    //     features: ["ניהול פגישות ומעקב", "תזכורות אוטומטיות", "אפשרויות גבייה מגוונות"],
    //     color: "teal"
    //   }
  ];

  return (
    <section id="business-categories">
      <Box
        py={60}
        style={{
          background: "linear-gradient(135deg, rgba(247, 250, 252, 0.5) 0%, rgba(255, 255, 255, 1) 100%)",
        }}
      >
        <Container size="xl">
          <Title
            order={2}
            ta="center"
            fw={800}
            className={classes.sectionTitle}
            mb={30}
            style={{
              fontFamily: "'Rubik', 'Heebo', sans-serif",
              fontWeight: 900,
              fontSize: "clamp(2rem, 3.5vw, 2.8rem)",
              lineHeight: 1.1,
              marginBottom: 20,
              letterSpacing: "-0.03em",
              background: "linear-gradient(135deg, #1a1040 0%, #3d2b7a 60%, #667eea 100%)",
              "-webkit-background-clip": "text",
              "-webkit-text-fill-color": "transparent",
              "background-clip": "text",
            }}
          >
            QuickTor פותחה במיוחד לתחום הביוטי מתוך הבנה עמוקה של ניהול הקליניקה שלכם
          </Title>

          <Text
            size="xl"
            ta="center"
            mb={60}
            mx="auto"
            maw={800}
            style={{
              fontFamily: "'Rubik', 'Heebo', sans-serif",
              fontSize: "clamp(1.125rem, 2vw, 1.375rem)",
              lineHeight: 1.7,
              color: "var(--mantine-color-gray-7)",
              fontWeight: 400,
            }}
          >
            אנחנו לא עוד מערכת לניהול תורים. הקמנו את QuickTor כדי להעניק לכם את המעטפת המלאה שהעסק שלכם צריך הכל במקום אחד ללא צורך יותר באפליקציות חיצוניות!
          </Text>

          <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="xl">
            {businessCategories.map((category, index) => (
              <Card
                key={index}
                shadow="md"
                padding="sm"
                radius="xl"
                withBorder
                className={classes.categoryCard}
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.06)",
                  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 250, 252, 0.98) 100%)",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04)",
                  transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Card.Section>
                  <Box pos="relative" style={{ overflow: "hidden", borderRadius: "16px 16px 0 0" }}>
                    <Image
                      src={category.image}
                      height={220}
                      alt={category.altText}
                      style={{
                        transition: "transform 0.5s ease",
                      }}
                    />
                    {/* <Badge
                      bg={category.color}
                      size="lg"
                      pos="absolute"
                      top={16}
                      left={16}
                      pr={16}
                      pl={16}
                      style={{
                        background: "rgba(255, 255, 255, 0.95)",
                        backdropFilter: "blur(10px)",
                        fontWeight: 700,
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                      }}
                    >
                      {category.title}
                    </Badge> */}
                  </Box>
                </Card.Section>

                <Box mt="xl" px="md" pb="md">
                  <Text
                    fw={800}
                    size="xl"
                    mb={12}
                    style={{
                      fontSize: "clamp(1.25rem, 2vw, 1.5rem)",
                      letterSpacing: "-0.01em",
                      color: "var(--mantine-color-dark-8)",
                    }}
                  >
                    {category.title}
                  </Text>
                  <Text
                    size="md"
                    lineClamp={4}
                    mb={20}
                    style={{
                      lineHeight: 1.7,
                      color: "var(--mantine-color-gray-7)",
                    }}
                  >
                    {category.description}
                  </Text>

                  <Box mb={24}>
                    {category.features.map((feature, i) => (
                      <Group key={i} gap={12} mb={10}>
                        <ThemeIcon
                          color={category.color}
                          variant="light"
                          size={28}
                          radius="xl"
                          style={{
                            background: `linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)`,
                            border: `1px solid rgba(102, 126, 234, 0.2)`,
                            transition: "all 0.3s ease",
                          }}
                        >
                          <IconStar size={18} />
                        </ThemeIcon>
                        <Text
                          size="sm"
                          fw={500}
                          style={{
                            color: "var(--mantine-color-gray-7)",
                            lineHeight: 1.6,
                          }}
                        >
                          {feature}
                        </Text>
                      </Group>
                    ))}
                  </Box>
                </Box>

                <Button
                  component="a"
                  href={category.link}
                  variant="filled"
                  color={category.color}
                  fullWidth
                  rightSection={<IconArrowRight size={18} />}
                  size="sm"
                  radius="xl"
                  fw={700}
                  style={{
                    background: `linear-gradient(135deg, #667eea 0%, #764ba2 100%)`,
                    border: "none",
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 8px 25px rgba(102, 126, 234, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.3)";
                  }}
                >
                  לכל הפתרונות ל{category.title}
                </Button>
              </Card>
            ))}
          </SimpleGrid>

          <Paper
            withBorder
            p={40}
            mt={60}
            radius="xl"
            style={{
              background: "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
              border: "1px solid rgba(102, 126, 234, 0.1)",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Grid>
              <Grid.Col span={{ base: 12, md: 8 }}>
                <Title
                  order={3}
                  mb={16}
                  fw={800}
                  style={{
                    fontSize: "clamp(1.5rem, 3vw, 2rem)",
                    letterSpacing: "-0.01em",
                    color: "var(--mantine-color-dark-8)",
                  }}
                >
                  רוצים לדעת איך QuickTor תתאים לעסק שלכם?
                </Title>
                <Text
                  size="lg"
                  style={{
                    lineHeight: 1.7,
                    color: "var(--mantine-color-gray-7)",
                  }}
                >
                  הצוות המקצועי שלנו מוכן להראות לכם כיצד המערכת יכולה להתאים
                  בדיוק לצרכים הייחודיים של העסק שלכם. קבלו הדגמה אישית וגלו
                  כיצד ניתן לחסוך זמן, להגדיל הכנסות ולשפר את חווית הלקוח.
                </Text>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4 }}>
                <Center h="100%">
                  <Button
                    size="xl"
                    rightSection={<IconArrowRight size={20} />}
                    component="a"
                    target="_blank"
                    href={`https://wa.me/972557259188?text=היי אני מעוניין להצטרף ל14 ימי ניסיון במערכת איך מתחילים?`}
                    radius="xl"
                    fw={700}
                    style={{
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      border: "none",
                      boxShadow: "0 8px 20px rgba(102, 126, 234, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow = "0 12px 30px rgba(102, 126, 234, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 8px 20px rgba(102, 126, 234, 0.3)";
                    }}
                  >
                    תיאום הדגמה אישית
                  </Button>
                </Center>
              </Grid.Col>
            </Grid>
          </Paper>
        </Container>
      </Box>
    </section>
  );
}
